import { apiClient } from "../../services/api";
import router from "../../router";

const state = () => ({
  user: null,
  users: null,
  perfis: null
});

const getters = {
  isAuthenticated: state => {
    return !!state.user;
  },
  username: state => {
    return state.user.dsc_login_usuario;
  },
  displayName: state => {
    const nome = state.user && state.user.nome;
    if (nome && nome.trim()) {
      return nome.trim().split(/\s+/).slice(0, 2).join(" ");
    }
    return state.user ? state.user.dsc_login_usuario : "";
  },
  email: state => {
    return state.user.email;
  },
  isAdm: state => {
    if (state.user.dsc_perfil === "ADMINISTRADOR") {
      return true;
    }
    return false;
  },
  getterUsers: state => {
    return state.users;
  },
  getterPerfis: state => {
    return state.perfis;
  }
};

const actions = {
  setUserData({ commit }, payload) {
    commit("setUserData", payload);
  },
  async getUserData({ commit }, payload) {
    const { dsc_login_usuario, email } = payload
    try {
      const response = await apiClient.get(
        `/listaUsuariosSocialCam?dsc_login_usuario=${dsc_login_usuario.toUpperCase()}`
      );
      if (response.status === 200) {
        const user = response.data.usuarios?.items[0]
        user.email = email
        commit("setUserData", user);
      }
    } catch (error) {
      return error.response.data;
    }
  },
  logout({ commit }) {
    commit("setUserData", null);
    localStorage.clear()
    router.push("/login").catch(() => {});
  },
  async getUsers({ commit }, payload) {
    const { page, size, dsc_excecao } = payload;
    try {
      const { data } = await apiClient.get(
        `/listaUsuariosSocialCamFront?page=${page}&size=${size}&dsc_login_usuario=${dsc_excecao}`
      );
      commit('setUsers', data.usuarios);
    } catch (error) {
      return error;
    }
  },
  async getPerfis({ commit }, payload) {
    const { page, size, cod_perfil } = payload;
    try {
      const { data } = await apiClient.get(
        `/listaPerfisSocialCamFront?page=${page}&size=${size}&cod_perfil=${cod_perfil}`
      );
      commit('setPerfis', data.perfis);
    } catch (error) {
      return error;
    }
  }
};

const mutations = {
  setUserData(state, payload) {
    state.user = payload;
  },
  setUsers(state, payload) {
    state.users = payload;
  },
  setPerfis(state, payload) {
    state.perfis = payload;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
